import { render } from "./SvgButton.vue?vue&type=template&id=213636cc&scoped=true&lang=html"
import script from "./SvgButton.vue?vue&type=script&lang=js"
export * from "./SvgButton.vue?vue&type=script&lang=js"

import "./SvgButton.vue?vue&type=style&index=0&id=213636cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213636cc"]])

export default __exports__